import { getLocalStorageEntry } from '../webStorageUtils';
import { LANGUAGE_PAIR_ID } from './saveLastLanguagePair';

export const getLanguagePairId = () => {
  const savedLanguagePairId = getLocalStorageEntry(LANGUAGE_PAIR_ID);
  const languagePairId = savedLanguagePairId && parseInt(savedLanguagePairId);

  if (!languagePairId || isNaN(languagePairId)) return null;

  return languagePairId;
};
